import { render } from "./BookingFormRoom.vue?vue&type=template&id=4b16c5df"
import script from "./BookingFormRoom.vue?vue&type=script&lang=js"
export * from "./BookingFormRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__